module.exports = __webpack_public_path__ + "img/logo.29029d91.png";